import { Component, OnInit } from '@angular/core';
import { ShaftRolesService } from '../../../shared/services/lookups/shaft-roles.service';
import { ShaftRoles } from '../../../shared/classes/lookups/shaft-roles.model';

@Component({
  selector: 'app-shaft-role',
  templateUrl: './shaft-role.component.html',
  styleUrls: ['./shaft-role.component.css']
})
export class ShaftRoleComponent implements OnInit {

  constructor(private shaftRolesService: ShaftRolesService) { }

  shaftRoles: ShaftRoles[];
  ngOnInit() {
    this.shaftRolesService.getShaftRoles().subscribe(data => {
      this.shaftRoles = data.map(e => {
        return {
          id: e.payload.doc.id,
          ...e.payload.doc.data()
        } as ShaftRoles;
      });
    });
  }

}
